var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "device-details" },
    [
      _c("loading-box", { attrs: { loading: _vm.loading } }),
      _vm.device
        ? _c(
            "div",
            [
              _c(_vm.deviceComponent, {
                tag: "component",
                attrs: { device: _vm.device, enableEdit: _vm.enableEdit }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }